import classNames from 'clsx';
import React, { memo, useCallback, useRef, useState } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { logHandler } from 'reactApp/ui/Datalist/DataList.helpers';
import FileIcon from 'reactApp/ui/FileIcon/FileIcon';
import { getIconType } from 'reactApp/ui/FileIcon/getIconType';
import { ImageCancelable } from 'reactApp/ui/ImageCancelable/ImageCancelable';

import styles from '../DataListItemThumb.css';
import { PicFileProps, PicFolderProps } from '../DataListItemThumb.types';

export const Pic = memo(function Pic(props: PicFileProps | PicFolderProps) {
    const iconType = getIconType({
        isFolder: props.isFolder,
        kind: props.isFolder ? props.kind : undefined,
        ext: props.isFolder ? undefined : props.ext.toLowerCase(),
        isVirus: props.isFolder ? false : props.isVirus,
        isAutoDelete: props.isFolder ? props.isAutoDelete : false,
    });

    const startTime = useRef(Date.now());
    const [isLoaded, setLoaded] = useState<boolean>(false);
    const isLoadingFolder = props.isFolder ? props.isLoading : false;
    const handleThumbLoad = useCallback(() => {
        setLoaded(true);

        logHandler({
            radarName: `thumb_load_success`,
            radars: [`all=${Date.now() - startTime.current}`],
        });
    }, []);

    const handleThumbError = useCallback(() => {
        logHandler({
            radarName: `thumb_load_fail`,
            radars: [`all=${Date.now() - startTime.current}`],
        });
    }, []);

    return (
        <div className={styles.container}>
            {!isLoaded && (
                <div
                    className={classNames({
                        [styles.icon]: true,
                        [styles.loading_folder]: isLoadingFolder,
                    })}
                >
                    <FileIcon type={iconType} view={EViewMode.thumbs} />
                </div>
            )}
            {!props.isFolder && props.thumbUrl?.src && (
                <ImageCancelable
                    className={classNames({
                        [styles.thumb]: true,
                        [styles.thumb_loaded]: isLoaded,
                    })}
                    draggable={false}
                    src={props.thumbUrl?.src}
                    srcSet={props.thumbUrl?.srcSet ? `${props.thumbUrl?.srcSet} 2x` : ''}
                    alt=""
                    onError={handleThumbError}
                    onLoad={handleThumbLoad}
                />
            )}
        </div>
    );
});
